import { CourseShort } from "./course-short.model";
import { FranchiseCourseDesign } from "./franchise-course-design.model";
import { FranchiseCourseSection } from "./franchise-course-section.model";
import { FranchisePreference } from "./franchise-preference.model";
import { GroupLanding } from "./group-landing.model";

export type FranchiseStatus = ('active'|'inactive');

export class FranchiseCourse {
    id?: number;
    status?: FranchiseStatus;
    url?: string;
    course?: CourseShort;
    sections?: FranchiseCourseSection[];
    design?: FranchiseCourseDesign;
    preferences?: FranchisePreference[];
    groups?: GroupLanding[];
    franchise?: any;

    static fromJson(fields: any): FranchiseCourse {
        let item = Object.assign(new this(), fields);
        item.course = CourseShort.fromJson(fields?.course);
        item.sections = fields?.sections?.map((item: any) => FranchiseCourseSection.fromJson(item));
        item.design = FranchiseCourseDesign.fromJson(fields?.design);
        item.preferences = fields?.preferences?.map((item: any) => FranchisePreference.fromJson(item));
        item.groups = fields?.groups?.map((item: any) => GroupLanding.fromJson(item));

        return item;
    }
}
